module.exports = __webpack_public_path__ + "media/images/products/IMG_20210704_165537_HDR-removebg-preview-cbcfc8f328f25dfd214c8aa1ea5e621f.png";